import React, { useContext, useEffect, useRef, useState } from "react";

import Grid from "@mui/material/Unstable_Grid2";
import WebMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import Graphic from "@arcgis/core/Graphic";
import Editor from "@arcgis/core/widgets/Editor";
import AddServiceAreaSideBar from "./AddServiceAreaSideBar";
import esrirequest from "@arcgis/core/request";
import { processProjectData } from "../../utils/ProjectAPI";
import { ServiceIndex } from "../../config/APIRoutes";
import AuthContext from "../../context/auth/AuthContext";
import ProjectContext from "../../context/project/ProjectContext";
import { Button } from "@mui/material";

function ServiceAreaEditor() {
  console.log("Editor Body....");

  const projectContext = useContext(ProjectContext);
  const authContext = useContext(AuthContext);
  let { user } = authContext;
  const {
    serviceAreaFeatures,
    serviceAreas,
    selectedProject,
    getServiceAreasV2,
    getServiceAreaFeaturesV2,
    getAllServiceAreasV2,
    intelliFiberUserRoles,
  } = projectContext;

  const [webmap, setWebMap] = useState();
  const [view, setView] = useState();
  const [editor, setEditor] = useState();
  const [projectServiceAreas, setProjectServiceAreas] = useState();
  const [projectServiceAreaFeatures, setProjectServiceAreaFeatures] =
    useState();

  const webmapRef = React.useRef(webmap);
  const viewRef = React.useRef(view);
  const editorRef = React.useRef(view);
  const fileInputRef = useRef(null);
  const [uploadFileName, setUploadFileName] = useState();
  const featureLayerRef = React.useRef(null);

  const getUserRoleType = () => {
    //check User's Role
    if (intelliFiberUserRoles && intelliFiberUserRoles.length > 0) {
      console.log("$$$USER :", user);
      const role = intelliFiberUserRoles.find(
        (item) => item.UserID === user?.userID
      );
      console.log("$$$USER Role:", role);
      if (role) {
        return role.RoleName ? role.RoleName : "";
      }
    }
    return "";
  };

  const setMapRef = (newMap) => {
    webmapRef.current = newMap;
    setWebMap(newMap);
  };

  const setViewRef = (newView) => {
    viewRef.current = newView;
    setView(newView);
  };

  const setEditorRef = (newEditor) => {
    editorRef.current = newEditor;
    setEditor(newEditor);
  };

  let areaMapRef = useRef(null);

  function generateFeatureCollection(fileName) {
    let name = fileName.split(".");
    console.log("##Updated FileName:", name[0]);
    // Chrome adds c:\fakepath to the value - we need to remove it
    name = name[0].toLowerCase().replace("c:\\fakepath\\", "");
    let result1 = name[0].indexOf("c:\\fakepath\\");

    let result2 = name[0].substring(result1);
    console.log("##Updated res1:", result1);
    console.log("##Updated res2:", result2);
    console.log("##Updated FileName:", name);

    const params = {
      name: name,
      targetSR: viewRef.current.spatialReference,
      maxRecordCount: 1000,
      enforceInputFileSizeLimit: true,
      enforceOutputJsonSizeLimit: true,
    };

    // generalize features to 10 meters for better performance
    params.generalize = true;
    params.maxAllowableOffset = 10;
    params.reducePrecision = true;
    params.numberOfDigitsAfterDecimal = 0;

    const myContent = {
      filetype: "shapefile",
      publishParameters: JSON.stringify(params),
      f: "json",
    };

    // use the REST generate operation to generate a feature collection from the zipped shapefile
    esrirequest(
      process.env.REACT_APP_PORTAL_URL +
        "/sharing/rest/content/features/generate",
      {
        query: myContent,
        body: document.getElementById("uploadForm"),
        responseType: "json",
      }
    )
      .then((response) => {
        const layerName =
          response.data.featureCollection.layers[0].layerDefinition.name;
        // document.getElementById("upload-status").innerHTML =
        //   "<b>Loaded: </b>" + layerName;
        console.log("LAyer laoded", layerName);
        console.log("Featue LAyer ", response.data.featureCollection);
        addShapefileToMap(response.data.featureCollection);
        fileInputRef.current.value = null;
        setUploadFileName("");
      })
      .catch(errorHandler);
  }

  function errorHandler(error) {
    // document.getElementById("upload-status").innerHTML =
    //   "<p style='color:red;max-width: 500px;'>" + error.message + "</p>";
    console.log("Error:", error.message);
    fileInputRef.current.value = null;
    setUploadFileName("");
  }

  const UpdateProjectServiceArea = async (objectId) => {
    // const saID = getNewServiceAreaID();
    const payload = {
      OBJECTID: objectId,
      ProjectID: selectedProject.ID,
      // ID: saID.toString(),
      ProjectName: selectedProject.Name,
      AR_Trigger : "FILTER,JSI8675309"
    };

    const result = await processProjectData(
      ServiceIndex.ServiceArea,
      payload,
      "UPDATE"
    );
    console.log(`Updated New Service Area: ${result}`);
    fetchServiceAreas(selectedProject.ID);
    fetchServiceAreaFeatures(selectedProject.ID);
    fetchAllServiceAreas();
  };

  const fetchServiceAreas = async (projectId) => {
    // console.log("@@Fetch Assetd:", projectId);
    try {
      const serviceAreas = await getServiceAreasV2(projectId);
      // console.log("@@Assetd Lookup:", serviceAreas);
      // setProjectServiceAreas(ServiceAreas);
    } catch (error) {
      console.log("@@Service Areas Error:", error);
    }
  };

  const fetchServiceAreaFeatures = async (projectId) => {
    // console.log("@@Fetch Assetd:", projectId);
    try {
      const serviceAreaFeatures = await getServiceAreaFeaturesV2(projectId);
      // console.log("@@Assetd Lookup:", serviceAreaFeatures);
      // setProjectServiceAreas(ServiceAreas);
    } catch (error) {
      console.log("@@Service Areas Error:", error);
    }
  };

  const zoomToServiceArea = (objectId) => {
    // console.log("ZOOM fn called....", projectServiceAreaFeatures);
    const selectedArea = projectServiceAreaFeatures.filter(
      (item) => item.OBJECTID === objectId
    );
    const _extent = selectedArea[0].geometry.extent;
    const cloneExt = _extent.clone();
    // console.log("ZOOM ext....", cloneExt);
    viewRef.current.goTo({ extent: cloneExt.expand(1.5) });
    // viewRef.current.goTo(selectedArea[0].geometry);
  };

  const fetchAllServiceAreas = async () => {
    if (getAllServiceAreasV2) {
      try {
        getAllServiceAreasV2();
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const viewListener = () => {
    if (getUserRoleType() !== "Central GIS Team") {
      return;
    }
    console.log("View Editor Body....", viewRef.current);
    const tmpView = viewRef.current;
    // Create a custom group to separate the different areas of crime.
    // This function takes a 'grouping' object which contains a feature template and a feature layer.
    let editConfigServiceAreaLayer = null;
    // Loop through the webmap's layers and set an edit configuration
    tmpView.map.layers.forEach((layer) => {
      console.log("$$Layer title", layer.title);
      console.log("$$Layer name", layer.name);
      console.log("$$Layer lookup name", process.env.REACT_APP_FEATURE_SERVICE);
      console.log(
        "$$Layer check",
        layer.title === process.env.REACT_APP_FEATURE_SERVICE
      );
      if (layer.title === process.env.REACT_APP_FEATURE_SERVICE) {
        editConfigServiceAreaLayer = {
          layer: layer,
          formTemplate: {
            // Set it so that only one field displays within the form
            elements: [
              {
                type: "field",
                fieldName: "Name",
                label: "Name",
              },
              {
                type: "field",
                fieldName: "Description",
                label: "Description",
              },
              {
                type: "field",
                fieldName: "AR_Trigger",
                label: "AR Trigger",
                visibilityExpression: "alwaysHidden",
                editableExpression: "alwaysHidden",
                valueExpression: "hardCoded",
              },
              {
                type: "field",
                fieldName: "ProjectID",
                label: "ProjectID",
                visibilityExpression: "alwaysHidden",
                editableExpression: "alwaysHidden",
                valueExpression: "PRJ_ID",
              },
            ],
            expressionInfos: [
              {
                name: "alwaysHidden",
                expression: "1 == 0",
              },
              {
                name: "hardCoded",
                expression: "'FILTER,JSI8675309'",
              },
              {
                name: "PRJ_ID",
                expression: `'${selectedProject.ID}'`,
              },
            ],
          },
        };
        // setEditConfigServiceAreaLayer(editConfigServiceAreaLayer);
      }
    });

    console.log("##SAL:", editConfigServiceAreaLayer);
    // Filter and display templates only if their labels contain the word `Street`
    function includeServiceArea(filter) {
      console.log("##SAL NAMESS:", filter);
      let containsName = filter.label.includes(
        process.env.REACT_APP_FEATURE_SERVICE
      );
      console.log("##SAL NAMESS:", containsName);
      return containsName;
      // return true;
    }
    tmpView
      .whenLayerView(editConfigServiceAreaLayer.layer)
      .then(function (layerView) {
        // do something with the layerView
        layerView.filter = {
          where: "ProjectID='" + selectedProject.ID + "'",
        };
      });
    // Create the Editor
    const tmpEditor = new Editor({
      view: tmpView,
      // Pass in the configurations created above
      layerInfos: [editConfigServiceAreaLayer],
      // Override the default template behavior of the Editor widget
      supportingWidgetDefaults: {
        featureTemplates: {
          visibleElements: {
            filter: false, // disable the default filter UI
          },
          filterFunction: includeServiceArea,
        },
      },
      visibleElements: { snappingControls: false },
    });

    tmpEditor.viewModel.watch("state", function (state) {
      console.log("$$Editor Event:", state);
    });

    featureLayerRef.current = editConfigServiceAreaLayer.layer;
    editConfigServiceAreaLayer.layer.on("edits", function (event) {
      if (event.deletedFeatures.length > 0) {
        console.log("Editor Delete Event:", event.deletedFeatures);
        //Refresh the Service Areas list
        fetchServiceAreas(selectedProject.ID);
        fetchServiceAreaFeatures(selectedProject.ID);
      }
      if (event.addedFeatures.length > 0) {
        console.log("Editor Added Event:", event.addedFeatures);      
      //Update Service Area with Project ID
        UpdateProjectServiceArea(event.addedFeatures[0].objectId);

         //Refresh the Service Areas list
      }
      if (event.updatedFeatures.length > 0) {
        console.log("Editor Updated Event:", event.updatedFeatures);       
        //Refresh the Service Areas list
        fetchServiceAreas(selectedProject.ID);
        fetchServiceAreaFeatures(selectedProject.ID);       
      }
      console.log("Editor Event Complete , Fetch Service Area:");
      // fetchServiceAreas(selectedProject.ID);
    });

    editorRef.current = tmpEditor;
    // Add widget to the view
    tmpView.ui.add(tmpEditor, "top-right");
  };

  useEffect(() => {
    console.log("Component Mount....");
    // esriConfig.portalUrl = "https://intelli-fiber-dev.jsitel.com/portal";
    // initPortal();
    const tmpWebmap = new WebMap({
      portalItem: {
        // id: API_Service.WebMapUrl,
        id: process.env.REACT_APP_WEB_MAP_ID,
      },
    });
    webmapRef.current = tmpWebmap;
    setMapRef(tmpWebmap);

    //As setMapRef is async below mapref could possible null?
    const tmpView = new MapView({
      container: areaMapRef.current,
      map: webmapRef.current,
    });

    console.log("Temp View....", tmpView);
    tmpView.when(viewListener);
    viewRef.current = tmpView;

    fetchServiceAreas(selectedProject.ID);
    fetchServiceAreaFeatures(selectedProject.ID);
    return () => {
      const tmpView = viewRef.current;
      console.log("View destroyin....");
      tmpView && tmpView.destroy();
      setMapRef(null);
      setViewRef(null);
      setEditorRef(null);
      console.log("View destroyed....");
    };
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("Updating Service Areas....");
    if (serviceAreas) {
      setProjectServiceAreas(serviceAreas);
    }
  }, [serviceAreas]);

  useEffect(() => {
    console.log("Updating Service Area Features....");
    if (serviceAreaFeatures) {
      setProjectServiceAreaFeatures(serviceAreaFeatures);
    }
  }, [serviceAreaFeatures]);

  const onFormChange = (event) => {
    const fileName = event.target.value.toLowerCase();
    console.log("Form Change Filename...", fileName);

    if (fileName.indexOf(".zip") !== -1 || fileName.indexOf(".shp") !== -1) {
      //is file a zip - if not notify user
      // generateFeatureCollection(fileName);
      setUploadFileName(fileName);
      document.getElementById("upload-status").innerHTML = "";
    } else {
      document.getElementById("upload-status").innerHTML =
        '<p style="color:red">Add shapefile as .zip file</p>';
      setUploadFileName("");
    }
  };

  const submitFileUpload = (e) => {
    e.preventDefault();
    console.log("Form Submit Filename...", uploadFileName);
    generateFeatureCollection(uploadFileName);
    // fileInputRef.current.value = "";
  };

  const clearFileUpload = (e) => {
    e.preventDefault();
    fileInputRef.current.value = null;
    setUploadFileName("");
  };

  function addShapefileToMap(featureCollection) {
    // add the shapefile to the map and zoom to the feature collection extent
    // if you want to persist the feature collection when you reload browser, you could store the
    // collection in local storage by serializing the layer using featureLayer.toJson()
    // see the 'Feature Collection in Local Storage' sample for an example of how to work with local storage
    let sourceGraphics = [];
    const featureLayer = featureLayerRef.current;
    const mapView = viewRef.current;
    const layers = featureCollection.layers.map(async (layer) => {
      const graphics = layer.featureSet.features.map((feature) => {
        return Graphic.fromJSON(feature);
      });

      const newFeatures = layer.featureSet.features.map((feature, index) => {
        feature.attributes = {
          Name: `ServiceArea-${index}`,
          Description: `ServiceArea Description-${index}`,
          ProjectID: selectedProject.ID,
        };
        return {
          geometry: {
            ...feature.geometry,
            type: "polygon",
          },
          attributes: feature.attributes,
        };
      });
      console.log("NEW Features::", newFeatures);
      const featureLayerView = await mapView.whenLayerView(featureLayer);

      // Add the new features to the feature layer

      await featureLayer.applyEdits({ addFeatures: newFeatures });

      // Refresh the feature layer to show the new features
      featureLayerView.refresh();
      return featureLayer;
      // associate the feature with the popup on click to enable highlight and zoom to
    });
  }

  return (
    <Grid container className="center-pane">
      <Grid xs={9} className="center-pane">
        <div
          ref={areaMapRef}
          id="viewDiv"
          style={{
            width: "100%",
            height: "100%",
            minHeight: "70vh",
            padding: 20,
            margin: 5,
            borderStyle: "groove",
            borderColor: "pallete.primary.contrast",
          }}
        ></div>
      </Grid>

      <Grid xs={3} sx={{ textAlign: "center" }}>
        {getUserRoleType() === "Central GIS Team" && (
          <form
            encType="multipart/form-data"
            method="post"
            id="uploadForm"
            onChange={onFormChange}
          >
            <div className="field">
              <label className="file-upload">
                <span>
                  <strong>Upload a SHP file in .zip format</strong>
                </span>
                <div style={{ margin: "10px" }}>
                  <Button variant="contained" component="label" width="50px">
                    <input
                      type="file"
                      name="file"
                      id="inFile"
                      ref={fileInputRef}
                      style={{ maxWidth: "210px" }}
                    />
                  </Button>
                </div>
              </label>
            </div>
            <span
              className="file-upload-status"
              style={{ opacity: 1 }}
              id="upload-status"
            ></span>
            <div id="fileInfo"></div>
            <div>
              <Button
                variant="contained"
                type="button"
                color="secondary"
                onClick={clearFileUpload}
                sx={{ px: 1, mx: 1 }}
                disabled={
                  !uploadFileName ||
                  uploadFileName === null ||
                  uploadFileName === ""
                }
              >
                Clear
              </Button>
              <Button
                variant="contained"
                type="submit"
                color="secondary"
                onClick={submitFileUpload}
                sx={{ px: 1, mx: 1 }}
                disabled={
                  !uploadFileName ||
                  uploadFileName === null ||
                  uploadFileName === ""
                }
              >
                Submit
              </Button>
            </div>
          </form>
        )}

        <AddServiceAreaSideBar
          action="add"
          serviceAreas={projectServiceAreas}
          zoomToServiceArea={zoomToServiceArea}
        />
      </Grid>
    </Grid>
  );
}

export default ServiceAreaEditor;
